<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'mb-4 ' + config!.cssClass : 'form-group'"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}
    @if (config ? showAsterisk(config) : false) {
      *
    }
    <ng-template #tooltip>
      <div [innerHtml]="config?.tooltip"></div>
    </ng-template>
    @if (config?.tooltip) {
      <i
        class="far fa-question-circle"
        [ngbTooltip]="tooltip"
      ></i>
    }
  </label>
  <select
    class="form-select"
    [formControlName]="config?.name ?? null"
    [id]="config?.name"
    [ngClass]="{ 'is-valid': valid, 'is-invalid': invalid }"
    [attr.aria-describedby]="config?.name + 'err'"
    [attr.data-testid]="config?.name"
    (change)="onChange($event)"
  >
    @if (config?.hasPlaceholder !== false) {
      <option
        disabled
        [value]="undefined"
      >{{ config?.placeholder || '' }}</option>
    }
    @for (option of config?.options; track $index) {
      <option
        [value]="option.value"
        [attr.disabled]="option.disabled ? '' : null"
        [attr.hidden]="option.hidden ? '' : null"
        [attr.data-testid]="'option_' + option.value"
      >
        {{ option.text }}
      </option>
    }
  </select>

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
